//export const URL_SERVICIOS='http://10.0.0.98:8080/restExplora/index.php';
//export const URL_IMG='http://10.0.0.98:8080/restExplora/public/img/';

export const URL_SERVICIOS='https://explorapass.com.mx/restExplora/index.php';
export const URL_IMG='https://explorapass.com.mx/restExplora/public/img/';



// WEBPACK FOOTER //
// C:/Users/EZepeda/Desktop/Explora/adminexplora/src/conf/url.servicios.ts